import React from 'react';
import PropTypes from 'prop-types';
import '../Subscription/SubscriptionConfig.scss';


const StyleGuideNav = ({ onClick, activeItemName }) => {

    function renderItem(name) {
        const isActive = (name == activeItemName) ? 'list-group-item active' : 'list-group-item';
        const btnName = "btn" + name;
        const displayName = name.split("_").join(" ");
        return <button id={btnName} className={isActive} onClick={onClick}>{displayName}</button>
    }

    return (
        <ul className="list-group list-group-flush">
            <button className="list-group-item list-group-header">v5 STYLE GUIDE</button>
            {renderItem("Basics")}
            {renderItem("Charts")}
            {renderItem("Components")}
            {renderItem("Drawers")}
            {renderItem("Forms")}
            {renderItem("Icons")}
            {renderItem("Notifications")}
            {renderItem("Tables")}
            {renderItem("Heatmap")}
        </ul>
    );
}
StyleGuideNav.propTypes = {
    activeItemName: PropTypes.string,
    onClick: PropTypes.func.isRequired
};

export default StyleGuideNav
